import { render, staticRenderFns } from "./box-post.vue?vue&type=template&id=2928f534&scoped=true&"
import script from "./box-post.vue?vue&type=script&lang=js&"
export * from "./box-post.vue?vue&type=script&lang=js&"
import style0 from "./box-post.vue?vue&type=style&index=0&id=2928f534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928f534",
  null
  
)

export default component.exports